export const saleInfo = () => [
  {
    label: 'Sale Information',
    type: 'TITLE',
  },
  {
    endpoint: 'sales',
    column: 'amount',
    source: 'transactions',
    label: 'Sale Amount',
    default: 'N/A',
    type: 'TEXT_TABLE',
    unit: 'DOLLARS',
  },
  {
    endpoint: 'sales',
    column: 'sale_date',
    sortBy: 'sale_date',
    source: 'transactions',
    default: 'N/A',
    label: 'Sale Date',
    type: 'TEXT_TABLE',
  },
  {
    endpoint: 'sales',
    column: 'grantor',
    source: 'transactions',
    label: 'Grantor',
    type: 'TEXT_TABLE',
  },
  {
    endpoint: 'sales',
    column: 'grantee',
    source: 'transactions',
    label: 'Grantee',
    type: 'TEXT_TABLE',
  },
  {
    endpoint: 'sales',
    column: 'deed_type',
    source: 'transactions',
    label: 'Deed Type',
    type: 'TEXT_TABLE',
  },
  {
    endpoint: 'sales',
    column: 'transaction_type',
    source: 'transactions',
    label: 'Transaction Type',
    type: 'TEXT_TABLE',
    last: true,
  },
  {
    label: 'Average Sale Price',
    type: 'TITLE',
  },
  {
    label: 'Average Residential Sale Price',
    title: 'Average Residential Sale Price',
    graph: 'avg_transactions_prc_single_parcel',
    type: 'LINE_GRAPH',
    useRatio: false,
    unit: 'Price per Square Foot',
    renameColumn: 'res_sale_price',
    radius: 1000,
    compare: [
      {
        to: 'CITY',
        label: 'Average Sale Price for the city',
        graph: 'avg_transactions_prc',
      },
    ],
  },
  {
    label: 'Average Commercial Sale Price',
    title: 'Average Commercial Sale Price',
    graph: 'avg_transactions_prc_commercial_single_parcel',
    type: 'LINE_GRAPH',
    useRatio: false,
    unit: 'Price per Square Foot',
    renameColumn: 'com_sale_price',
    radius: 1000,
    compare: [
      {
        to: 'CITY',
        label: 'Average Sale Price for the city',
        graph: 'avg_transactions_prc_commercial',
      },
    ],
  },
];
